/**
 * Checks if a user is an EvalOps staff member based on their email domain
 * @param email The user's email address to check
 * @returns True if the email belongs to an EvalOps staff member, false otherwise
 */
export const isEvalOpsStaff = (email: string): boolean => {
  return email.toLowerCase().endsWith('@evalops.dev');
}; 